import { render, staticRenderFns } from "./CapturaHuella.vue?vue&type=template&id=1d4dbe55&scoped=true"
import script from "./CapturaHuella.vue?vue&type=script&lang=js"
export * from "./CapturaHuella.vue?vue&type=script&lang=js"
import style0 from "./CapturaHuella.vue?vue&type=style&index=0&id=1d4dbe55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4dbe55",
  null
  
)

export default component.exports